<div [ngClass]="{'row h-100 w-100 m-0': !isAdvisor}">
  <div class="padding-right">
    <app-messages *ngIf="errorAdvisor" [msgArr]="[{text: errorInConfirm}]"></app-messages>
  </div>
  <div *ngIf="!isAdvisor && !isNewForm" class="image-width p-0 " style="z-index: 3;">
    <div class="image-side"></div>
  </div>

  <div *ngIf="!isFinish">
    <div *ngIf="!isloading">
      <div *ngIf="phonesAvailableSubject|async">
        <div class="d-flex flex-column mt-md-0 login-page-padding-top">
          <!--title-->
          <div class="mb-4 text-md-right text-center mr-md-3 mr-sm-1">
            <h1 class="app-title-xxlarge mt-1">{{"otp.title"|translate}}</h1>
          </div>
        </div>
      </div>

      <div *ngIf="isNewForm">
        <div class="padding-right">
          <app-messages *ngIf="errorInConfirm !== ''" [msgArr]="[{text: errorInConfirm}]"></app-messages>
        </div>
        <app-get-code [phones]="[phoneNumber]" (submitCb)="getCodeNewForm($event)" *ngIf="(currentStepSubject|async)===1"></app-get-code>
        <app-confirm-code [phone]="phoneNumber" (submitCb)="cofirmCode($event)" (backCb)="goToGetCode()"
          *ngIf="(currentStepSubject|async)===2">
        </app-confirm-code>
      </div>

      <div *ngIf="phonesAvailableSubject|async" class="container d-flex flex-column justify-content-center">

        <div class="padding-right header-width">
          <app-messages *ngIf="errorInConfirm !== ''" [msgArr]="[{text: errorInConfirm}]"></app-messages>
        </div>

        <app-get-code [phones]="phones" (submitCb)="getCode($event)" *ngIf="(currentStepSubject|async)===1">
        </app-get-code>

        <app-confirm-code [phone]="phones[selectedPhoneIndex]" (submitCb)="cofirmCode($event)" (backCb)="goToGetCode()"
          *ngIf="(currentStepSubject|async)===2">
        </app-confirm-code>

      </div>
      <div *ngIf="noPhonesForIDSubject|async"
        class="d-flex flex-column justify-content-center text-center m-step-wrapper1 container">
        <div class="d-flex flex-column mt-md-0 login-page-padding-top">
          <!--title-->
          <div class="mb-4 text-md-right text-center mr-md-3 mr-sm-1">
            <h1 class="app-title-xxlarge mt-1">{{"otp.errors.no-phones"|translate}}</h1>
          </div>
        </div>
      </div>

      <div *ngIf="advisorNotExist|async"
        class="d-flex flex-column justify-content-center text-center m-step-wrapper1 container">
        <div class="d-flex flex-column mt-md-0 login-page-padding-top">
          <!--title-->
          <div class="mb-4 text-md-right text-center mr-md-3 mr-sm-1">
            <h1 class="app-title-xxlarge mt-1">{{"otp.errors.advisor1"|translate}}</h1>
            <h1 class="app-title-xxlarge mt-1">{{"otp.errors.advisor2"|translate}}</h1>
            <a href="https://www.mizrahi-tefahot.co.il/contact-us#nav-contact-list-2"
              class="app-title-xxlarge mt-1 app-text-decoration">
              {{"otp.errors.advisor3"|translate}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="{'header-width header-zone': !isAdvisor}">
    <div class="text-center mt-5" *ngIf="isFinish && !isloading">
      <div class="padding-right">
        <app-messages *ngIf="errorInConfirm !== ''" [msgArr]="[{text: errorInConfirm}]"></app-messages>
      </div>
      <h1 class="app-title-xxlarge mt-5 text-center">{{"otp.finish1"|translate}}</h1>
      <h1 class="app-title-xxlarge text-center">{{"otp.finish2"|translate}}</h1>
      <button (click)="finish()" class="app-button button-primary mt-5">{{"otp.proceed-btn2"|translate}}</button>
    </div>
  </div>
  <div *ngIf="isloading" class="mx-4 mt-md-0 mt-5">
    <app-loader-page [isloading]="isloading"></app-loader-page>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/login/otp/otp.component.html